import { connect } from 'react-redux';
import { IAppState } from '../core/redux/IAppState';
import { defaultMapDispatchToProps, defaultMergeProps } from '../core/redux/sugar';


/**
 * ConfigView: a function that connects a component to the Redux store's config
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default connect(
  (state: IAppState) => ({
    config:   state.resortToolsConfig,
    userRole: state.userState.role,
  }),
  defaultMapDispatchToProps,
  defaultMergeProps,
  {
    // By default, props are recalculated for every state change -- this is how you specify when to recalculate.
    // Because this component is used basically everywhere, we want it to have maximum performance.
    // Only recalculate props if `auth` state has changed.
    areStatesEqual: (next: IAppState, prev: IAppState) => next.resortToolsConfig === prev.resortToolsConfig
                                                          && next.userState.role === prev.userState.role,
  },
);
